import { isArray } from 'lodash';

const TYPES = {
  KEY: 'key',
  LABEL: 'label',
};

export default {
  name: 'WCheckboxGroup',
  props: {
    labelClasses: {
      default: '',
      type: String,
    },
    name: {
      required: true,
      type: String,
    },
    options: {
      required: true,
      type: Array,
    },
    returnObject: {
      default: false,
      type: Boolean,
    },
    textAttribute: {
      default: TYPES.LABEL,
      type: String,
    },
    valueAttribute: {
      default: TYPES.KEY,
      type: String,
    },
    value: [Number, String, Array, Object, null],
  },
  data() {
    return {
      selected: {},
    };
  },
  watch: {
    selected(newVal) {
      if (this.returnObject) {
        this.$emit('input', newVal);
      } else {
        const result = Object.keys(newVal)?.filter((key) => !!newVal[key]) || [];
        this.$emit('input', result);
      }
    },
  },
  computed: {
    formattedOptions() {
      if (this.isArrayItems) {
        return this.options?.map((option) => ({
          label: option,
          key: option,
        }));
      }
      return this.options;
    },
    isArrayItems() {
      return isArray(this.options?.[0] || {});
    },
    label() {
      return this.isArrayItems ? TYPES.LABEL : this.textAttribute;
    },
    key() {
      return this.isArrayItems ? TYPES.KEY : this.valueAttribute;
    },
  },
};
